<template>
  <b-sidebar
    id="sidebar-accept-or-reject-quote-agreement"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Reject or accept') }}
        </h5>

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="quoteAgreementUpdate">

          <b-form-group
            :label="$t('Status')"
            label-for="status"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Status')"
              rules="required"
            >
              <v-select
                id="status"
                v-model="quoteAgreement.status"
                :options="statuses"
                :reduce="(option) => option.id"
                :get-option-label="(option) => $t(option.label)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Faqat REJECT tanlansa -->
          <b-form-group
            v-if="quoteAgreement.status === QuoteAgreementStatus.REJECTED"
            :label="$t('Rejected info')"
            label-for="reject_info"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Rejected info')"
              rules="required"
            >
              <b-form-textarea
                id="rejected-info"
                v-model="quoteAgreement.reject_info"
                trim
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              :variant="'success'"
              class="mr-2"
              type="submit"
              @click="submit(hide)"
            >
              {{ $t('Submit') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="clear(hide)"
            >
              {{ $t('Cancel') }}
            </b-button>
          </div>
        </validation-observer>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BButton, VBToggle, BSidebar, BForm, BFormTextarea, BFormGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import vSelect from 'vue-select'
import { required } from '@/libs/validations/validations'
import { QuoteAgreementStatus } from '@/views/pages/quote-agreement/quote-agreement-data'

export default {
  name: 'AcceptOrReject',
  components: {
    BButton,
    BSidebar,
    BForm,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    BFormGroup,
    vSelect,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    QuoteAgreementStatus() {
      return QuoteAgreementStatus
    },
    quoteAgreement: {
      get() {
        return this.$store.state[this.MODULE_NAME].quoteAgreement
      },
      set(data) {
        this.$store.commit('quoteAgreement/UPDATE', data)
      },
    },
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.$store.commit('quoteAgreement/FRESH')
      this.$refs.quoteAgreementUpdate.reset()
      hide()
    },
    submit(hide) {
      this.$refs.quoteAgreementUpdate.validate().then(success => {
        if (success) {
          this.$createSwal(this, {
            body: {
              status: this.quoteAgreement.status,
              reject_info: this.quoteAgreement.reject_info,
            },
            id: this.quoteAgreement.id,
          }, 'quoteAgreement/patch', () => {
            this.$emit('refetchData')
            this.$store.commit('quoteAgreement/FRESH')
          })
          hide()
        }
      })
    },
  },
  setup() {
    const statuses = [
      { id: QuoteAgreementStatus.ACCEPTED, label: 'Accept' },
      { id: QuoteAgreementStatus.REJECTED, label: 'Reject' },
    ]
    const MODULE_NAME = 'quoteAgreement'
    return {
      MODULE_NAME,
      statuses,
    }
  },
}
</script>

<style scoped>

</style>
